export const FD_PAGE_GUTTER = 40;

export const FD_HOME_SPACING = {
  heroTop: 15,
  heroLogoTop: 80,
  heroLogoToHeading: 120,
  heroHeadingToCta: 40,
  heroBottom: 140,
  sectionTop: 70,
  headingBlock: 60,
  headingToContent: 110,
  sectionBottom: 110,
  carouselTop: 110,
  carouselBottom: 80,
  carouselHeight: 420,
  curatedTop: 80,
  curatedBottom: 110,
  curatedCardsHeight: 430,
  footerBottom: 40,
};

export const FD_STEP1_COLORS = {
  hero: "#000000",
  pageBottom: "#FFFFFF",
  card: "#ECEAE6",
  form: "#FFFFFF",
  note: "#E9E7E1",
};

export const FD_STEP1_SPACING = {
  heroLogoTop: 48,
  heroLogoToTitle: 120,
  heroTitleToCard: 96,
  cardOverlapRatio: 0.3,
  cardSideInset: 48,
  cardBottom: 88,
  leftLogoTop: 44,
  leftLogoSide: 44,
  leftNoteGap: 72,
  leftBottom: 44,
  formCardTopInset: 32,
  formCardRightInset: 28,
  formCardBottomInset: 44,
  formInnerTop: 40,
  formInnerSide: 32,
  formInnerBottom: 44,
  fieldGap: 48,
  ideaHeight: 220,
  navHeight: 52,
  navTopGap: 44,
};
